import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar, 
  Card,
  CardContent,
  Grid, 
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined';
const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.indigo[600],
    height: 56,
    width: 56
  }
}));

const InvoiceWaiting = (props,{ className, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              PROCESSED  
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
             {props.matrix?props.matrix.Processed:0}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <HourglassEmptyOutlinedIcon />
            </Avatar>
          </Grid>
        </Grid> 
      </CardContent>
    </Card>
  );
};

InvoiceWaiting.propTypes = {
  className: PropTypes.string
}; 

export default InvoiceWaiting;
